import { useState } from 'react';
import { squaredToValue } from '../lib/helpers';

export const useFilterControls = (sendCommand) => {
    // Filter controls (default: SVF at 400Hz)
    const [filterType, setFilterType] = useState('SVF');
    const [cutoffSlider, setCutoffSlider] = useState(Math.sqrt((400 - 20) / (20000 - 20)));
    const [resonanceSlider, setResonanceSlider] = useState(Math.sqrt(0.3));

    // Handlers
    const handleFilterTypeChange = (type) => {
        setFilterType(type);
        sendCommand('filter.type', type);
    };

    const handleCutoffChange = (sliderPos) => {
        setCutoffSlider(sliderPos);
        const actualValue = squaredToValue(sliderPos, 20, 20000);
        sendCommand('filter.cutoff', actualValue.toFixed(1));
    };

    const handleResonanceChange = (sliderPos) => {
        setResonanceSlider(sliderPos);
        const actualValue = squaredToValue(sliderPos, 0, 1);
        sendCommand('filter.res', actualValue.toFixed(3));
    };

    // Computed actual values
    const cutoffActual = squaredToValue(cutoffSlider, 20, 20000);
    const resonanceActual = squaredToValue(resonanceSlider, 0, 1);

    return {
        // Values
        filterType,
        cutoffSlider,
        cutoffActual,
        resonanceSlider,
        resonanceActual,
        
        // Handlers
        handleFilterTypeChange,
        handleCutoffChange,
        handleResonanceChange
    };
};
